import { Pipe, PipeTransform, inject } from '@angular/core';
import { AuthService, UserRole } from '@core/auth/services/auth-service';

@Pipe({
  name: 'notHasRole',
  standalone: true
})
export class NotHasRolePipe implements PipeTransform {
  private authService = inject(AuthService);

  transform(role: UserRole): boolean {
    return !this.authService.hasRole(role);
  }
}
